import { Navigate, useNavigate } from 'react-router-dom';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../hooks/use-is-firm-role';
import { BadgeV3, Button } from '@cimplico/components';
import { ArrowSmallLeftIcon } from '@heroicons/react/20/solid';
import FYIGroupsOnboarding from '../features/firm-overview/firm-settings/integrations/fyi/onboarding/groups/FYIGroupsOnboarding';
import PageContainer from '../components/page-container/PageContainer';
import PageTitle from '../components/PageTitle';
import NewGroupForm from '../features/new-group/NewGroupForm';
import useQueryParam from '../hooks/use-query-param';

const providers = ['fyi'];

function NewGroupPage(): JSX.Element {
    const provider = useQueryParam('provider', providers, 'manual');
    const navigate = useNavigate();
    const activeSubscription = useIsActiveSubscription();
    const { isExternalUser } = useIsFirmRole();

    const title = provider === 'fyi' ? 'Add Groups From FYI' : 'New Group';

    if (!activeSubscription || isExternalUser) {
        return <Navigate to=".." />;
    }

    return (
        <PageContainer>
            <div className="pb-4">
                {provider === 'fyi' && (
                    <Button
                        leftIcon={<ArrowSmallLeftIcon className="w-5 h-5" />}
                        onClick={(): void => navigate(`..`)}
                        size="md"
                        type="hollow"
                        label="Back to groups"
                    />
                )}
                <div className="pb-4 pt-2 border-b flex items-center gap-2">
                    <PageTitle title={title} />
                    {provider === 'fyi' && <BadgeV3 size="small" rounded={false} color="indigo" label="Beta" />}
                </div>
                {provider === 'manual' && <NewGroupForm />}
                {provider === 'fyi' && <FYIGroupsOnboarding fullPage />}
            </div>
        </PageContainer>
    );
}
export default NewGroupPage;
